import { useCallback, useRef } from 'react'

/**
 * Returns focus to the control that opened a dialog. Call ``remember`` when
 * opening and pass ``restore`` as the dialog's ``onCloseAutoFocus`` (dialogs
 * opened through state have no trigger for Radix to refocus).
 */
export function useReturnFocus() {
  const trigger = useRef<HTMLElement | null>(null)
  const remember = useCallback(() => {
    trigger.current = document.activeElement as HTMLElement | null
  }, [])
  const restore = useCallback((event?: Event) => {
    event?.preventDefault()
    const target = trigger.current
    // After the close re-render: the trigger may have been disabled meanwhile.
    requestAnimationFrame(() => {
      if (target?.isConnected && !target.matches(':disabled')) target.focus()
    })
  }, [])
  return { remember, restore }
}
